import React, { createContext, useContext } from 'react';

type Props = {
  children: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pageProps?: any;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const AppContext = createContext<any>({
  cookies: '',
  referrer: '',
  id: '',
  height_or_hash: '',
  hash: '',
  number: '',
  q: '',
});

export function AppContextProvider({ children, pageProps }: Props) {
  return (
    <AppContext.Provider value={ pageProps }>
      { children }
    </AppContext.Provider>
  );
}

export function useAppContext() {
  return useContext(AppContext);
}
